import React from 'react';
import {
  MenuItem,
  Grid,
  TextField,
} from '@mui/material';
import {
  ChipOption,
  ChipSelectList,
  MultiCountrySelector,
  Option,
} from '@marageti/z4-lib';
import { Agent } from '@marageti/z4-sdk/lib/people';
import { CountryObject } from './options';
import SpecialistSelect from '../../../components/specialist-select';
import TripSearchDateRangeFilters, {
  TripSearchDateRangeKey,
} from '../../../components/trip-search-date-range-filters/trip-search-date-range-filters';

type PartnerTripsFiltersProps = {
  assignedTo: string;
  countries: string[];
  departureDateFrom: string;
  departureDateTo: string;
  disableSortBy: boolean;
  matchDateFrom: string;
  matchDateTo: string;
  onChange: (n: string, v: string | string[]) => void;
  partnerCountryOptions: CountryObject[];
  partnerAgents: Agent[];
  searchValue: string;
  selectedStatusChips: string[];
  sortBy: string;
  sortByOptions: Option[];
  statusChipOptions: ChipOption[];
};

const PartnerTripsFilters = ({
  assignedTo,
  countries,
  departureDateFrom,
  departureDateTo,
  disableSortBy,
  matchDateFrom,
  matchDateTo,
  onChange,
  partnerCountryOptions,
  partnerAgents,
  searchValue,
  selectedStatusChips,
  sortBy,
  sortByOptions,
  statusChipOptions,
}: PartnerTripsFiltersProps) => {
  const onDateChange = (name: TripSearchDateRangeKey, value: string) => {
    onChange(name, value);
  };

  return (
    <>
      <Grid container spacing={{ mobile: 0, desktop: 2 }} mb={0} gap={0}>
        <Grid item mobile={12} desktop={3}>
          <TextField
            fullWidth
            key="search-term"
            label="Search"
            name="searchTerm"
            onChange={(e) => onChange('fullText', e.target.value)}
            value={searchValue}
          />
        </Grid>
        <Grid item mobile={12} desktop={3}>
          <MultiCountrySelector
            countries={partnerCountryOptions}
            key="countries-select"
            label="Primary Countries"
            name="countries"
            onChange={(e: React.SyntheticEvent, value: string[]) => onChange('countries', value)}
            value={countries}
          />
        </Grid>
        <Grid item mobile={12} desktop={3}>
          <SpecialistSelect
            assignedTo={assignedTo}
            onChange={(value) => onChange('assignedTo', value)}
            agents={partnerAgents}
          />
        </Grid>
        <Grid item mobile={12} desktop={3}>
          <TextField
            key="sort-by-select"
            label="Sort By"
            name="sort"
            onChange={(e) => onChange('sort', e.target.value)}
            select
            sx={{
              width: '100%',
              '& .MuiSelect-icon > svg > path': { color: 'primary.main' },
            }}
            disabled={disableSortBy}
            value={sortBy}
          >
            {sortByOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.title}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Grid container spacing={{ mobile: 0, desktop: 2 }} mb={4}>
        <Grid item mobile={12} desktop={12}>
          <TripSearchDateRangeFilters
            departureDateFrom={departureDateFrom}
            departureDateTo={departureDateTo}
            matchDateFrom={matchDateFrom}
            matchDateTo={matchDateTo}
            onChange={onDateChange}
          />
        </Grid>
        <Grid item mobile={12} desktop={12}>
          <ChipSelectList
            chipOptions={statusChipOptions}
            label="Status"
            onChange={(v: string[]) => onChange('status', v)}
            selectedChips={selectedStatusChips}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PartnerTripsFilters;
